import { noop } from 'rxjs';
import { BaseService, NULL_SERVICE, Service } from '../base/service';

export interface IndentService extends Service {
  readonly canIndent: boolean;
  readonly canOutdent: boolean;

  indent(): void;
  outdent(): void;
}

export const NULL_INDENT_SERVICE: IndentService = {
  ...NULL_SERVICE,

  canIndent: false,
  canOutdent: false,

  indent: noop,
  outdent: noop,
};

export function createCombinationIndentService(...indentServices: IndentService[]): IndentService {
  return new CombinationIndentService(...indentServices);
}

export class CombinationIndentService extends BaseService implements IndentService {
  constructor(...indentServices: IndentService[]) {
    super(...indentServices);

    this.indentServices = indentServices;
  }

  private readonly indentServices: IndentService[];

  get canIndent() {
    return this.indentServices.some(service => service.canIndent);
  }

  get canOutdent() {
    return this.indentServices.some(service => service.canOutdent);
  }

  indent() {
    const service = this.indentServices.find(candidate => candidate.canIndent);
    if (service) {
      service.indent();
    }
  }

  outdent() {
    const service = this.indentServices.find(candidate => candidate.canOutdent);
    if (service) {
      service.outdent();
    }
  }
}
